import { Component, OnInit } from '@angular/core';
import { PosFloatingActionButtonService } from 'src/app/@core/services/pos-floating-action-button.service';

@Component({
  selector: 'app-delivery-ticket',
  templateUrl: './delivery-ticket.component.html',
  styleUrls: ['./delivery-ticket.component.sass']
})
export class DeliveryTicketComponent implements OnInit {

  constructor(private floatingService: PosFloatingActionButtonService) {
    this.floatingService.setShow(false);
    this.floatingService.addItems();
  }

  ngOnInit(): void {
  }

}
